require('../../modules/es.object.values');
var path = require('../../internals/path');

module.exports = path.Object.values;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/values.js
// module id = 6455
// module chunks = 25